
export const pluck = (arr, key) => arr.map(i => i[key]);
